var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoUploadSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 182,
    viewBox: "0 0 160 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 117C28.9697 117 19.5467 113.161 11.7309 105.483C3.91515 97.8047 0.00484848 88.4203 0 77.3297C0 67.8234 2.84848 59.3531 8.54545 51.9188C14.2424 44.4844 21.697 39.7312 30.9091 37.6594C33.9394 26.4469 40 17.3672 49.0909 10.4203C58.1818 3.47344 68.4848 0 80 0C94.1818 0 106.213 4.96763 116.095 14.9029C125.976 24.8381 130.914 36.933 130.909 51.1875C139.273 52.1625 146.213 55.7895 151.731 62.0685C157.248 68.3475 160.005 75.6892 160 84.0938C160 93.2344 156.819 101.005 150.458 107.406C144.097 113.807 136.368 117.005 127.273 117H40Z",
    fill: "url(#paint0_linear_776_1554)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 138.5C117.5 158.935 100.935 175.5 80.5 175.5C60.0655 175.5 43.5 158.935 43.5 138.5C43.5 118.065 60.0655 101.5 80.5 101.5C100.935 101.5 117.5 118.065 117.5 138.5Z",
    fill: "#48BD69",
    stroke: "#D9F5E1",
    strokeWidth: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94 129L74.0625 148L65 139.364",
    fill: "#48BD69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94 129L74.0625 148L65 139.364",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_776_1554",
    x1: 218.914,
    y1: -0.367983,
    x2: 25.9885,
    y2: 76.7596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUploadSuccess);
export default __webpack_public_path__ + "static/media/videoUploadSuccess.be63f2829195390b743b518c7244e75d.svg";
export { ForwardRef as ReactComponent };